const typography = {
  fontWeights: {
    robotoLight: 300,
    robotoRegular: 400,
    robotoBold: 700
  }
};

export default typography;
